import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import message from 'antd/lib/message';
import { connect } from 'react-redux';
import { FFConnectionRequestKYCStyles } from './FFConnectionRequestKYC.styles';
import { addKYCText, connectKYCText } from './FFConnectionRequestKYC.common';
import { SelectedFilters } from '../DiscoverRate/TypesInDiscoverRates/SelectedFilters';
import { ShipperOrganisation } from '../DiscoverRate/TypesInDiscoverRates/SearchResult';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';
import AddKYCForm from './AddKYCForm';
import { useGenericState } from 'src/Library/UseGenericState';
import { KYCData, KYCInfo } from './KycConnections.types';
import { sendConnectionRequest } from 'src/api/masters';

interface FFConnectionRequestKYCProps extends
  StylesProps<ReturnType<typeof FFConnectionRequestKYCStyles>> {
  isVisible: boolean;
  firstTime: boolean;
  selectedFilters: SelectedFilters;
  kycData: KYCData [];
  onCancel: () => void;
  ffOrganisation: ShipperOrganisation;
  createBooking: () => void;
  isGeneratingBookingData: boolean;
}

interface StateProps {
  isAddKYCFormVisible: boolean;
  isLoading: boolean;
}

const FFConnectionRequestKYC = (props: FFConnectionRequestKYCProps): React.ReactElement => {

  const {
    isVisible,
    classes,
    firstTime,
    kycData,
    onCancel,
    ffOrganisation,
    createBooking,
    isGeneratingBookingData,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    isAddKYCFormVisible: false,
    isLoading: false,
  });

  const {
    isAddKYCFormVisible,
    isLoading,
  } = state;

  const renderTitle = () => {
    return (
      <Row gutter={24}>
        <Col span={14} style={{ fontWeight: 600 }}>FF Connection Request </Col>
        <Col span={10}>
          {!firstTime && <div className={classes.editKyc}>
            <span style={{ fontWeight: 600 }}>KYC Details</span>
            <span className={classes.modifyKYC}
              onClick={() => setState({ isAddKYCFormVisible: true })}>Modify</span>
          </div>}
        </Col>
      </Row>
    );
  };

  const handleOk = () => {
    if (firstTime) {
      setState({ isAddKYCFormVisible: true });
    } else {
      handleSubmit()
    }
  };

  const getKYCData = () => {
    const kycDataObj : KYCInfo [] = kycData?.map(item => ({
        code: item.code,
        value: item.defaultValue,
    })) || [];
    return kycDataObj;
  }

  const handleSubmit = async () => {
    setState({ isLoading: true });
    const response = await sendConnectionRequest({
      targetOrganisationId: ffOrganisation?.id,
      kycData: getKYCData(),
    });
    if (!response.isSuccess) {
      message.error(response.errorMessage)
    } else {
      createBooking();
    }
    setState({ isLoading: false });
  }

  return (
    <Modal
      visible={isVisible}
      zIndex={1000}
      width={400}
      className={classes.modal}
      title={renderTitle()}
      closable={false}
      onCancel={onCancel}
      footer={
        <React.Fragment>
          <span className={classes.skipButton}
            onClick={() => onCancel()}>Cancel</span>
          <Button
            className={classes.okButton}
            onClick={() => handleOk()}
            loading={isLoading || isGeneratingBookingData}
          >{firstTime ? 'Add KYC Details' : 'Submit'}</Button>
        </React.Fragment>
      }
    >
      <div style={{ marginBottom: '30px' }}>{connectKYCText(ffOrganisation?.name)}</div>
      {addKYCText(ffOrganisation?.name)}
      {isAddKYCFormVisible &&
        <AddKYCForm
          isVisible={isAddKYCFormVisible}
          isGeneratingBookingData={isGeneratingBookingData}
          onCancel={async (success) => {
            success && await createBooking();
            setState({
              isAddKYCFormVisible: false,
            })
          }}
          targetOrganisationId={ffOrganisation?.id}
          kycData={kycData} />}
    </Modal>
  );
};

const mapStateToProps = ({ discoverRatesReducer, inquiryShipperReducer }, ownProps) => ({
  selectedFilters: discoverRatesReducer.selectedFilters,
  createInquiryData: inquiryShipperReducer.createInquiryData,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getAllDataSetFilter,
  }, dispatch);
};

export default connect(mapStateToProps,
  mapDispatchToProps)(withStyles(FFConnectionRequestKYCStyles)(FFConnectionRequestKYC));
